import { Component, OnInit } from '@angular/core';
import { NotificationsService } from './notifications.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
  title = 'Notifications';
  key = 'alert_status';
  reverse = true;
  p = 1;
  alerts;
  term = '';

  constructor(private notificationsService: NotificationsService) {
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  ngOnInit() {
    this.fetchAllAlerts();
  }

  closeAlert(alertId: string) {
    this.alerts.forEach(alert => {
      if (alert.id === alertId) {
        alert.alert_status = 'Closed';
        this.notificationsService.updateNotification(alert);
      }
    });
  }

  /**
   * Fetch all the alerts for a user
   * adds display values to root level for angular table search and sort features (consider using DTO)
   */
  fetchAllAlerts(): any {
    this.notificationsService.getAllNotifications().then(
      alerts => {
        alerts.forEach(alert => {
          alert.location_name = alert.details.location_name;
          alert.room_name = alert.details.room_name;
          alert.device_name = alert.details.device_name;
          alert.description = alert.details.description;
          alert.create_time = alert.details.create_time;
        });
        this.alerts = alerts;
      });
  }

  public getCellColor(warningLevel: string): string {
    console.log('level:' + warningLevel);
    let color = 'black';
    switch (warningLevel) {
      case 'Low': {
        color = 'green';
        break;
      }
      case 'Medium': {
        color = 'yellow';
        break;
      }
      case 'High': {
        color = 'red';
        break;
      }
      default: {
        break;
      }
    }

    return color;

  }

}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/notifications/notifications.component.ts